import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import RtkBaseQueryWithReauth from './RtkBaseQueryWithReauth';
import ApiPath from "./ConstantApi";

export const CountryTaxService = createApi({
  reducerPath: "CountryTaxService",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: () => ({
        url: `${ApiPath.getAllCountries}`,
        method: "GET",
      }),
      transformResponse: (response: { data: any }) => response.data,
    }),
  }),
});

export const { useGetAllCountriesQuery } = CountryTaxService;